import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../components/Input.tsx';
//import TopBar from '../components/TopBar';
import '../App.css'; // Includes the GlobalContainer gradient
import '../styles/MainContainer.css'; // Additional styles if needed
import { useAccount } from 'wagmi';
import rot13 from '../utils/encode.ts'
import { BASE_URL } from '../utils/constants.ts';

const Referral = () => {
  // State for copy button functionality
  const { address } = useAccount()
  const referralLink = address ? `${BASE_URL}/?ref=${rot13(address)}` : `${BASE_URL}/?ref=`;
  const [copied, setCopied] = useState(false);

  // State for FAQ accordion
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // Copy button handler
  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Revert after 2 seconds
  };

  // FAQ toggle handler
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // FAQ data with updated capitalization
  const faqItems = [
    {
      question: 'How do I use my referral link?',
      answer:
        'Share your referral link and enjoy our platform with your friends - when they link their wallet through your referral link, you will automatically be registered as a referrer.',
    },
    {
      question: 'When do I receive points?',
      answer:
        'Points are awarded when your invited friend connects to your wallet via a referral link.',
    },
  ];

  return (
    <div className="GlobalContainer">
      <div>
        
        {/* Main Content */}
        <div className="max-w-7xl m-auto pt-36 pb-24 px-4 sm:py-10">
          {/* Banner Section with Text Overlay */}
          <div className="w-full flex rounded-[10px] overflow-hidden mb-6 relative">
            <img src="/img/banner.jpg" alt="Referral Banner" className="w-full" />
            {/* Text Overlay */}
            <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4 top-[50%] sm:top-[67%]">
              <h1
                className="text-white text-[30px] sm:text-[48px] font-bold leading-tight tracking-[-2%]"
                style={{ textShadow: '3px 3px 6px rgba(0, 0, 0, 0.7)' }}
              >
                Referral Program
              </h1>
            </div>
          </div>
          <p
            className="text-white text-[16px] sm:text-[20px] font-bold mt-2 text-center"
            style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' }}
          >
            Invite friends and earn points together!
          </p>

          {/* Buttons Section */}
          <div className="my-6 flex flex-col sm:flex-row m-auto justify-center gap-4">
            <Link
              to="/"
              className="relative flex h-[50px] w-full sm:w-[167px] items-center justify-center rounded-[16px] bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-subtitle1 text-white"
            >
              Start Trading
            </Link>
            <Link
              to="/create"
              className="relative flex h-[50px] w-full sm:w-[167px] items-center justify-center rounded-[16px] bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-subtitle1 text-white"
            >
              Create a Coin
            </Link>
          </div>

          {/* Referral Content */}
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Your Referral Link Section */}
            <div className="lg:w-1/2 bg-[#050f1a] px-[16px] py-[14px] bg-[#6d79ad33] rounded-[10px] backdrop-blur-[8px] border-2 border-[#ffffff66]">
              <h2 className="text-[#fff] text-[20px] font-bold flex items-center">
                <PersonIcon className="mr-2 w-5 h-5 text-[#7db4e5]" />
                Your Referral Link
              </h2>
              <div className="flex items-center mt-2">
                <Input
                  value={copied ? 'Copied!' : referralLink}
                  type="text"
                  placeholder="Your referral link will appear here"
                  readOnly={true}
                  className="flex-1 bg-[#1c252677] text-[#d3d3d3] rounded-[10px] p-2"
                />
                <button
                  onClick={handleCopy}
                  className="ml-2 p-2 bg-[#1c2526] rounded hover:bg-[#2a3435]"
                  title="Copy to clipboard"
                  aria-label="Copy referral link"
                >
                  <ClipboardIcon className="w-5 h-5 text-[#fff]" />
                </button>
              </div>
            </div>

            {/* Point Reward Information Section */}
            <div className="lg:w-1/2 bg-[#050f1a] px-[16px] py-[14px] bg-[#6d79ad33] rounded-[10px] backdrop-blur-[8px] border-2 border-[#ffffff66]">
              <h2 className="text-[#fff] text-[20px] font-bold flex items-center">
                <GiftIcon className="mr-2 w-5 h-5 text-[#7db4e5]" />
                Point Reward Information
              </h2>
              <ul className="mt-2 text-[#fff] list-none">
                <li className="before:content-['•'] before:text-[#7db4e5] before:mr-2">
                  Earn points when your referee trades.
                </li>
                <li className="before:content-['•'] before:text-[#7db4e5] before:mr-2">
                  Earn points when your referee launches a token.
                </li>
              </ul>
            </div>
          </div>

          {/* FAQ Section (styled like Faq.jsx) */}
          <div className="mt-6">
            <h2 className="text-[#fff] text-[20px] font-bold mb-4">FAQ</h2>
            <div className="flex flex-col">
              {faqItems.map((item, index) => (
                <div key={index} className="flex flex-col" style={{ marginTop: '20px' }}>
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="bg-[#050f1a] rounded-[10px] lg:px-8 px-2.5 py-5 flex justify-between items-center w-full text-left focus:outline-none bg-[#6d79ad33] backdrop-blur-[8px] border-2 border-[#ffffff66]"
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="text-[#fff] text-[11px] lg:text-[14px] max-w-[90%]">
                      {item.question}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`h-6 stroke-[#fcfcfc] w-6 shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''
                        }`}
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </button>
                  {openIndex === index && (
                    <div
                      className="lg:px-8 px-2.5 py-5 bg-[#6d79ad33] rounded-[10px] backdrop-blur-[8px] border-2"
                      style={{
                        border: '2px solid #050f1a',
                      }}
                    >
                      <p className="text-[#fff] text-[11px] lg:text-[14px] pt-5">
                        {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Icon Components (Simple SVG Placeholders)
const PersonIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

const GiftIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v13m0-13V6a2 2 0 11-4 0c0 1.1.9 2 2 2h4a2 2 0 100-4h-2m-4 8h8m-8 0h8m-8 4h8"
    />
  </svg>
);

const ClipboardIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-2m-2-2h-4m0 0h4m-4 0v2h4V3m-4 6h4"
    />
  </svg>
);

export default Referral;